// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2Wtxn","controls":"styles_controls__1xdnC","charLimit":"styles_charLimit__1Ez2h","input":"styles_input__vHhip","send":"styles_send__31ptr"};